


















































import { Component, Vue, Prop } from "vue-property-decorator";
import { clearFilter } from "@/utils/base";
import { LoginOut, PutEditPaw } from "@/request/common";
import { GetVersionList } from "@/request/version";
@Component({})
export default class Login extends Vue {
  private ifEditPassword: any = false;
  private editData: any = {};
  private get user() {
    return this.$store.state.user;
  }
  private get href() {
    return window.location.href;
  }
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private goRouter(item: any) {
    if (!item.path) {
      return;
    }
    this.$store.commit("updatePatient", null);
    clearFilter();
    this.$router.push(item.path);
  }
  private handleSystem(command: any) { }
  /**
   * @description 点击切换账号
   */
  private handleCommand(command: any) {
    if (command === "机构信息") {
      this.$router.push("/main/setting/account");
    } else if (command === "修改密码") {
      this.editData = JSON.parse(JSON.stringify(this.user));
      this.ifEditPassword = true;
    } else if (command === "账户管理") {
      this.$router.push("/main/account/zhanghu-list");
    } else if (command === "退出登录") {
      this.exit();
    } else if (command === "检测升级") {
      const loading = this.$loading({
        lock: true,
        text: "检测中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      let params: any = {
        params: {
          name: "河南UI",
        },
      };
      GetVersionList(this, params, loading).then((res: any) => {
        console.log(res);
        const version = this.systemInfo.VERSION;
        console.log("当前版本");
        console.log(version);
        if (
          res.items &&
          res.items.length > 0 &&
          res.items[0]["fields"] &&
          res.items[0]["fields"]["软件版本号"] &&
          res.items[0]["fields"]["软件版本号"].length > 0 &&
          res.items[0]["fields"]["软件版本号"][0].text
        ) {
          console.log("最新版本");
          const cVersion = res.items[0]["fields"]["软件版本号"][0].text;
          console.log(cVersion);
          if (cVersion && cVersion != version) {
            this.$confirm("有新版本，是否更新？", "", {
              customClass: "commonConfirm",
              confirmButtonClass: "iconfont icon-anniu4 confirmSure",
              cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
              cancelButtonText: "不更新",
              confirmButtonText: "更新",
              // showCancelButton: false,
              closeOnClickModal: false,
              // closeOnPressEscape: false,
            }).then(() => {
              const url = res.items[0]["fields"]["软件版本URL"].link;
              console.log(url);
              // 使用 Electron 的下载 API
              let downloadLoading = this.$loading({
                lock: true,
                text: "下载中，请稍候...",
                spinner: "el-icon-loading",
                customClass: "loadClass",
                background: "rgba(255, 255, 255, 0.7)",
              });
              window.electronMyAPI
                .downloadFile(url)
                .then((result: any) => {
                  downloadLoading.close();
                  if (result.success) {
                    this.$message.success("下载成功，正在打开...");
                    let openLoading = this.$loading({
                      lock: true,
                      text: "打开中，请稍候...",
                      spinner: "el-icon-loading",
                      customClass: "loadClass",
                      background: "rgba(255, 255, 255, 0.7)",
                    });
                    window.electronMyAPI
                      .openPath(result.path)
                      .then(() => {
                        openLoading.close();
                      })
                      .catch(() => {
                        openLoading.close();
                      });
                  } else {
                    this.$message.error("下载失败：" + result.message);
                  }
                })
                .catch((error: any) => {
                  downloadLoading.close();
                  this.$message.error("下载出错：" + error);
                });
            }).catch(() => {
              // 用户取消更新，不做任何处理
              console.log("用户取消更新");
            });
          } else {
            this.$message.warning("当前已是最新版本");
          }
        }
      });
    }
  }
  private savePassword() {
    // 验证
    if (!this.editData.oldPassword) {
      this.$message.warning("请输入旧密码");
      return;
    }
    if (!this.editData.newPassword) {
      this.$message.warning("请输入新密码");
      return;
    }
    if (!this.editData.rePassword) {
      this.$message.warning("请再次输入新密码");
      return;
    }
    if (this.editData.newPassword !== this.editData.rePassword) {
      this.$message.warning("新密码2次输入不一致，请重新输入");
      return;
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      oldPassword: this.editData.oldPassword,
      newPassword: this.editData.newPassword,
      newPassword2: this.editData.rePassword,
    };
    PutEditPaw(this, params, loading).then(() => {
      this.ifEditPassword = false;
      this.exit();
    });
  }
  private exit() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    LoginOut(this, loading)
      .then(() => {
        loading.close();
        this.$message.success("退出成功");
        this.$store.commit("updateToken", "");
        this.$router.push("/access/login");
      })
      .catch(() => {
        loading.close();
      });
  }
  private mounted() {
    console.log(this.$store.state.systemInfo);
  }
}
